import React, { useState, useEffect } from "react";

import Swal from "sweetalert2";

// import { DropzoneDialog } from "material-ui-dropzone";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Checkbox,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Grid,
  MenuItem,
  TextField,
} from "@mui/material";
import { useMaterialUIController } from "context";
import getText from "Translator";
import { hasEmpty } from "controllers/validation";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { updateQuestion } from "controllers/QuestionController";
import { getHelpPages } from "controllers/MenuController";
import { storeQuestion } from "controllers/QuestionController";
import { displayErrorMessage } from "controllers/validation";
import { useNavigate } from "react-router-dom";
import NewAnaswer from "./NewAnswer";
import { getSubAnswers } from "controllers/QuestionController";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";

let emptyFeilds = {
  text: "",
  discription: "",
  floatCount: 2,
  goNextPage: false,
  displayTitle: true,
  fixTop: false,
  fixBottom: false,
  goBackPage: false,
  startText: "",
  hasHelpPage: false,
  helpPage: "",
  helpText: "help me",
  isRound: true,
  mandatory: true,
  multiMode: true,
  mainAnswerInMultiMode: true,
  multiModeVirgul: true,
  allowCopy: false,
  questionAnswers: "",
  questionCode: "",
  questionType: "",
  showForUser: true,
  tooltip: "",
  titleType: 1,
  size: 12,
  fontSize: null,
  answerSize: 12,
  clearOnLoad: false,
};
let BaseAnswerForRelatedAnswer;
let oldRelatedAnswer;
const NewQuestion = (props) => {
  const [controller] = useMaterialUIController();
  const [feilds, setFeilds] = useState(emptyFeilds);
  const [helpPageList, setHelpPageList] = useState();
  const [reload, setReload] = useState(new Date());
  const [topAnswers, setTopAnswers] = useState([]);
  const [answerList, setAnswerList] = useState([]);
  const [topAnswerValue, setTopAnswerValue] = useState("");
  const [open, setOpen] = useState(false);

  const [selectedExcelFile, setSelectedExcelFile] = useState();
  const [loading, setLoading] = useState(false);
  let { page, question, capsule, getData, resetAddQuestiobtnMode } = props;
  const navigate = useNavigate();

  const changeHandler = (event) => {
    // if (event.target.files[0].size > 307200) {
    //   Swal.fire({
    //     text: `حجم تصویر نمی تواند بیشتر از ۳۰۰ کلیوبایت باشد`,
    //     icon: "error",
    //     confirmButtonText: "متوجه شدم",
    //   });
    //   return;
    // }
    setSelectedExcelFile(event.target.files[0]);
  };
  const submitHandler = async () => {
    try {
      let emptyList = [];
      let emptyTextList = [];
      if (!feilds.text) {
        Swal.fire({
          text: getText("emptyalert", controller.lang),
          icon: "error",
        });
        return;
      }
      if (
        (feilds.questionType === "DB" || feilds.questionType === "DBS") &&
        !question
      ) {
        if (!selectedExcelFile) {
          Swal.fire({
            text: getText("emptyexcellfile", controller.lang),
            icon: "error",
          });
          return;
        }
      }

      if (feilds.questionType === "RANGE") {
        if (answerList.length === 0) {
          emptyList.push("");
          emptyTextList.push("Answer items");
        }
        answerList.map((item, index) => {
          emptyList.push(item.value);
          emptyTextList.push("Value " + (index + 1));
        });
        if (hasEmpty(emptyList, emptyTextList)) {
          return;
        }

        if (
          parseFloat(answerList[0].value + "") >=
          parseFloat(answerList[1].value + "")
        ) {
          Swal.fire({
            text: getText("invalidanswervalue", controller.lang),
            icon: "error",
          });
          return;
        }
      }

      let exi = 0;
      let errorx = false;
      if (
        feilds.questionType === "SELECT" ||
        feilds.questionType === "FLAT" ||
        feilds.questionType === "FLATB" ||
        feilds.questionType === "CHECKED" ||
        feilds.questionType === "MRD"
      ) {
        if (answerList.length === 0) {
          emptyList.push("");
          emptyTextList.push("Answer items");
          if (
            feilds.questionType === "FLAT" ||
            feilds.questionType === "FLATB"
          ) {
          }
        }
        answerList.map((item, index) => {
          emptyList.push(item.text);
          emptyTextList.push("Text " + (index + 1));
          emptyList.push(item.value);
          emptyTextList.push("Value " + (index + 1));
        });
        if (hasEmpty(emptyList, emptyTextList)) {
          return;
        }
        answerList.map((i) => {
          exi = 0;
          answerList.map((j) => {
            if (i.value === j.value || i.text === j.text) {
              exi += 1;
            }
          });
          if (exi > 1) {
            errorx = true;
          }
        });
      }
      if (errorx) {
        Swal.fire({
          text: getText("invalidanswervalue", controller.lang),
          icon: "warning",
        });
        return false;
      }
      let newQuestion = {};
      let result;
      if (question) {
        //edit mode
        newQuestion = {
          id: question._id,
          questionId: question.question._id,
          page: page,
          questionType: feilds.questionType,
          text: feilds.text,
          startText: feilds.startText,
          tooltip: feilds.tooltip,
          discription: feilds.discription,
          mandatory: feilds.mandatory,
          multiMode: feilds.multiMode,
          mainAnswerInMultiMode: feilds.mainAnswerInMultiMode,
          multiModeVirgul: feilds.multiModeVirgul,
          allowCopy: feilds.allowCopy,
          helpPage: feilds.hasHelpPage ? feilds.helpPage : undefined,
          helpText: feilds.helpText,
          lang: controller.lang,
          floatCount: feilds.isRound === true ? "0" : feilds.floatCount,
          goNextPage: feilds.goNextPage,
          displayTitle: feilds.displayTitle,
          fixTop: feilds.fixTop,
          fixBottom: feilds.fixBottom,
          goBackPage: feilds.goBackPage,
          showForUser: feilds.showForUser,
          isRound: feilds.isRound,
          size: feilds.size,
          fontSize: feilds.fontSize,
          answerSize: feilds.answerSize,
          titleType: feilds.titleType,
          answers: answerList,
          capsule: capsule,
          clearOnLoad: feilds.clearOnLoad,
        };
        result = await updateQuestion(
          controller.lang,
          newQuestion,
          selectedExcelFile,
          controller.token
        );
      } else {
        newQuestion = {
          page: page,
          questionType: feilds.questionType,
          text: feilds.text,
          startText: feilds.startText,
          tooltip: feilds.tooltip,
          discription: feilds.discription,
          mandatory: feilds.mandatory,
          multiMode: feilds.multiMode,
          mainAnswerInMultiMode: feilds.mainAnswerInMultiMode,
          multiModeVirgul: feilds.multiModeVirgul,
          allowCopy: feilds.allowCopy,
          helpPage: feilds.helpPage,
          helpText: feilds.helpText,
          lang: controller.lang,
          questionCode: feilds.questionCode,
          floatCount: feilds.floatCount,
          goNextPage: feilds.goNextPage,
          displayTitle: feilds.displayTitle,
          fixTop: feilds.fixTop,
          fixBottom: feilds.fixBottom,
          goBackPage: feilds.goBackPage,
          showForUser: feilds.showForUser,
          isRound: feilds.isRound,
          answers: answerList,
          size: feilds.size,
          fontSize: feilds.fontSize,
          answerSize: feilds.answerSize,
          titleType: feilds.titleType,
          capsule: capsule,
          clearOnLoad: feilds.clearOnLoad,
        };

        result = await storeQuestion(
          controller.lang,
          newQuestion,
          selectedExcelFile,
          controller.token
        );
      }
      if (result.success) {
        Swal.fire({
          text: question
            ? getText("editsuccesfully", controller.lang)
            : getText("insertsuccesfully", controller.lang),
          position: "top-end",
          icon: "success",
          showConfirmButton: false,
          timer: 1500,
        });

        getData();
        emptyFeilds.questionType = "";
        emptyFeilds.text = "";
        emptyFeilds.discription = "";
        emptyFeilds.floatCount = 2;
        emptyFeilds.goNextPage = false;
        emptyFeilds.displayTitle = false;
        emptyFeilds.fixTop = false;
        emptyFeilds.fixBottom = false;
        emptyFeilds.goBackPage = false;
        emptyFeilds.startText = "";
        emptyFeilds.hasHelpPage = false;
        emptyFeilds.helpPage = "";
        emptyFeilds.helpText = "help me";
        emptyFeilds.isRound = true;
        emptyFeilds.mandatory = true;
        emptyFeilds.multiMode = true;
        emptyFeilds.mainAnswerInMultiMode = true;
        emptyFeilds.multiModeVirgul = true;
        emptyFeilds.allowCopy = false;
        emptyFeilds.questionAnswers = "";
        emptyFeilds.questionCode = "";
        emptyFeilds.questionType = "";
        emptyFeilds.showForUser = true;
        emptyFeilds.tooltip = "";
        emptyFeilds.titleType = 1;
        emptyFeilds.size = 12;
        emptyFeilds.fontSize = "normal";
        emptyFeilds.answerSize = 12;
        emptyFeilds.clearOnLoad = false;
        setFeilds(emptyFeilds);
        setSelectedExcelFile();
        resetAddQuestiobtnMode();
        setReload(new Date());
      } else {
        if (result.errorCode === 101) {
          navigate("/", { replace: true });
        } else {
          displayErrorMessage(controller.lang, result.message, result.code);
        }
      }
    } catch (err) {
      console.log(err);
      Swal.fire({
        text: getText("generalerror", controller.lang),
        icon: "warning",
      });
    }
  };
  const handleClose = () => {
    setOpen(false);
  };
  const handleOpenRelatdAnswer = (answer, relatedAnswer) => {
    BaseAnswerForRelatedAnswer = answer;
    oldRelatedAnswer = relatedAnswer;
    setOpen(true);
  };
  useEffect(() => {
    setSelectedExcelFile();
    setFeilds(emptyFeilds);
    getHelpFormData();
    setLoading(false);
    setTopAnswers([]);
    if (question) {
      let editfeilds = {
        text: question.question.questiond.text,
        discription: question.question.questiond.discription,
        floatCount: question.floatCount,
        goNextPage: question.goNextPage,
        displayTitle: question.displayTitle,
        fixTop: question.fixTop,
        fixBottom: question.fixBottom,
        goBackPage: question.goBackPage,
        startText: question.question.questiond.startText,
        hasHelpPage: question.helpPage ? true : false,
        helpPage: question.helpPage,
        helpText: question.question.questiond.helpText,
        isRound: question.isRound,
        mandatory: question.mandatory,
        multiMode: question.question.multiMode,
        mainAnswerInMultiMode: question.question.mainAnswerInMultiMode,
        multiModeVirgul: question.question.multiModeVirgul,
        allowCopy: question.question.allowCopy,
        questionAnswers: question.question.answers,
        questionType: question.question.questionType,
        showForUser: question.showForUser ? question.showForUser : true,
        tooltip: question.question.questiond.tooltip,
        titleType: question.titleType ? question.titleType : 1,
        size: question.size ? question.size : 12,
        fontSize: question.fontSize ? question.fontSize : null,
        answerSize: question.answerSize ? question.answerSize : 12,
        clearOnLoad: question.question.clearOnLoad
          ? question.question.clearOnLoad
          : false,
      };
      setAnswerList(question.question.answers);
      setFeilds(editfeilds);
      setReload(new Date());
    }
  }, [question]);
  const getHelpFormData = async () => {
    try {
      let datas = await getHelpPages(
        controller.lang,
        { capsule },
        controller.token
      );
      setHelpPageList(datas.data);
    } catch (err) {
      console.log(err);
      Swal.fire({
        text: getText("generalerror", controller.lang),
        icon: "warning",
      });
    }
  };
  const setQuestionAnswers = (answers) => {
    if (!answers) {
      setAnswerList([]);
      return;
    }

    setAnswerList(answers);
  };
  const getSubAnswerHandler = async (topAnswer) => {
    try {
      if (!topAnswer) {
        setQuestionAnswers(question.question.answers);
        return;
      }
      let temp = topAnswers;
      if (temp.includes(topAnswer)) {
        temp = temp.filter((a) => a + "" !== "" + topAnswer);

        setTopAnswers(temp);

        if (temp.length == 0) {
          setQuestionAnswers(question.question.answers);
          return;
        }
      } else {
        temp.push(topAnswer);
      }

      let topAnswerValuex = question.question.answers.filter(
        (a) => a.id + "" == temp + ""
      );
      if (topAnswerValuex.length !== 0) {
        topAnswerValuex = topAnswerValuex[0].value;
      }
      setTopAnswerValue(topAnswerValuex);
      setTopAnswers(temp);
      let res = await getSubAnswers(
        controller.lang,
        { topAnswer: temp[temp.length - 1] },
        controller.token
      );
      setQuestionAnswers(res.data);
    } catch (err) {
      console.log(err);
    }
  };
  const questionTypeChangeHandler = (value) => {
    try {
      if (
        !(
          (feilds.questionType === "SELECT" ||
            feilds.questionType === "FLAT" ||
            feilds.questionType === "FLATB" ||
            feilds.questionType === "CHECKED" ||
            feilds.questionType === "MRD") &&
          (value === "SELECT" ||
            value === "FLAT" ||
            value === "FLATB" ||
            value === "CHECKED" ||
            value === "MRD")
        )
      ) {
        setAnswerList([]);
      }
      setSelectedExcelFile();
      let temp = feilds;
      temp.questionType = value;
      if (!feilds.hasHelpPage) {
        temp.helpPage = undefined;
      }
      setFeilds(temp);
      setReload(new Date());
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <Grid container>
      <Grid item xs={12} sm={12} md={12}>
        <div
          style={{
            fontSize: 13,
            fontWeight: "bold",
            color: "#BD4941",
          }}
        >
          {getText("questiontype", controller.lang)}
        </div>
        <TextField
          id="questionType"
          fullWidth
          style={{ minWidth: 350 }}
          onChange={(event) => {
            questionTypeChangeHandler(event.target.value);
          }}
          select
          value={feilds.questionType}
          variant="outlined"
        >
          <MenuItem key="TEXT" value="TEXT">
            متن
          </MenuItem>
          <MenuItem key="MEMO" value="MEMO">
            متن توضیحی
          </MenuItem>
          <MenuItem key="LINK" value="LINK">
            اطلاعات
          </MenuItem>
          <MenuItem key="INT" value="INT">
            عدد
          </MenuItem>
          <MenuItem key="RANGE" value="RANGE">
            بازه عددی
          </MenuItem>
          {/* 
          <MenuItem key="FLAT" value="FLAT">
            Select an option from among several options Flat View
          </MenuItem> */}
          <MenuItem key="FLATB" value="FLATB">
            انتخابی تخت
          </MenuItem>
          {/* <MenuItem key="CONTAINER" value="CONTAINER">
            Container
          </MenuItem> */}
          <MenuItem key="SELECT" value="SELECT">
            آبشاری
          </MenuItem>
          <MenuItem key="CHECKED" value="CHECKED">
            {/* Select an option from among several options */}
            تک انتخابی چک باکسی
          </MenuItem>
          <MenuItem key="MRD" value="MRD">
            چندانتخابی چک باکسی
          </MenuItem>
          <MenuItem key="CALC" value="CALC">
            فیلد محاسباتی
          </MenuItem>
          <MenuItem key="DATE" value="DATE">
            تاریخ
          </MenuItem>
          {/* <MenuItem key="DB" value="DB">
            DB
          </MenuItem> */}
          {/* <MenuItem key="DBS" value="DBS">
            DB Single Select
          </MenuItem> */}
        </TextField>
      </Grid>
      {feilds.questionType && (
        <>
          {/* <Grid item xs={12} sm={12} md={12} style={{ marginTop: 15 }}>
        <div
          style={{
            fontSize: 13,
            fontWeight: "bold",
            color: "#BD4941",
          }}
        >
          {getText("questioncode", controller.lang)}
        </div>
        <TextField
          id="questionCode"
          variant="outlined"
          type="number"
          fullWidth
          disabled={true}
          value={questionCode}
          onChange={(event) => {
            setQuestionCode(event.target.value);
          }}
        />
      </Grid> */}
          {feilds.questionType === "LINK" && (
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              style={{ marginTop: 5, marginBottom: 100 }}
            >
              <div
                style={{
                  fontSize: 13,
                  fontWeight: "bold",
                  color: "#BD4941",
                }}
              >
                {getText("text", controller.lang)}
              </div>
              <ReactQuill
                theme="snow"
                value={`${feilds.text}`}
                onChange={(event) => {
                  let temp = feilds;
                  temp.text = event.target.value;
                  setFeilds(temp);
                  setReload(new Date());
                }}
              />
            </Grid>
          )}
          {feilds.questionType !== "LINK" && (
            <>
              <Grid item xs={12} sm={12} md={12} style={{ marginTop: 15 }}>
                {/* {feilds.questionType === "CALC"
              ? getText("formula", controller.lang)
              :  */}
                <div
                  style={{
                    fontSize: 13,
                    fontWeight: "bold",
                    color: "#BD4941",
                  }}
                >
                  {getText("title", controller.lang)}
                </div>
                {/* } */}
                <TextField
                  id="text"
                  variant="outlined"
                  fullWidth
                  value={`${feilds.text}`}
                  onChange={(event) => {
                    let temp = feilds;
                    temp.text = event.target.value;
                    setFeilds(temp);
                    setReload(new Date());
                  }}
                />
              </Grid>

              {feilds.questionType !== "CONTAINER" && (
                <>
                  <Grid item xs={12} sm={12} md={12} style={{ marginTop: 15 }}>
                    <div
                      style={{
                        fontSize: 13,
                        fontWeight: "bold",
                        color: "#BD4941",
                      }}
                    >
                      {getText("tooltip", controller.lang)}
                    </div>
                    <TextField
                      id="tooltip"
                      variant="outlined"
                      fullWidth
                      value={`${feilds.tooltip}`}
                      onChange={(event) => {
                        let temp = feilds;
                        temp.tooltip = event.target.value;
                        setFeilds(temp);
                        setReload(new Date());
                      }}
                    />
                  </Grid>

                  {(feilds.questionType === "RANGE" ||
                    feilds.questionType === "FLAT" ||
                    feilds.questionType === "FLATB" ||
                    feilds.questionType === "TEXT" ||
                    feilds.questionType === "INT" ||
                    feilds.questionType === "MEMO" ||
                    feilds.questionType === "CALC" ||
                    feilds.questionType === "DATE" ||
                    feilds.questionType === "SELECT" ||
                    feilds.questionType === "DBS") && (
                    <Grid container spacing={2}>
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        md={6}
                        style={{ marginTop: 15 }}
                      >
                        <div
                          style={{
                            fontSize: 13,
                            fontWeight: "bold",
                            color: "#BD4941",
                          }}
                        >
                          {getText("displaysize", controller.lang)}
                        </div>
                        <TextField
                          id="displaysize"
                          variant="outlined"
                          fullWidth
                          value={`${feilds.size}`}
                          onChange={(event) => {
                            let temp = feilds;
                            temp.size = event.target.value;
                            setFeilds(temp);
                            setReload(new Date());
                          }}
                          select={true}
                        >
                          <MenuItem key="12" value={12}>
                            100%
                          </MenuItem>
                          <MenuItem key="6" value={6}>
                            50%
                          </MenuItem>
                          <MenuItem key="4" value={4}>
                            33%
                          </MenuItem>
                          <MenuItem key="2" value={2}>
                            16%
                          </MenuItem>
                          <MenuItem key="1" value={1}>
                            10%
                          </MenuItem>
                        </TextField>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        md={6}
                        style={{ marginTop: 15 }}
                      >
                        <div
                          style={{
                            fontSize: 13,
                            fontWeight: "bold",
                            color: "#BD4941",
                          }}
                        >
                          {getText("displaytype", controller.lang)}
                        </div>
                        <TextField
                          id="displaytype"
                          variant="outlined"
                          fullWidth
                          value={`${feilds.titleType}`}
                          onChange={(event) => {
                            let temp = feilds;
                            temp.titleType = event.target.value;
                            setFeilds(temp);
                            setReload(new Date());
                          }}
                          select={true}
                        >
                          <MenuItem key="1" value={1}>
                            Lable
                          </MenuItem>
                          <MenuItem key="2" value={2}>
                            inLine
                          </MenuItem>
                        </TextField>
                      </Grid>
                    </Grid>
                  )}

                  {(feilds.questionType === "SELECT" ||
                    feilds.questionType === "FLAT" ||
                    feilds.questionType === "FLATB" ||
                    feilds.questionType === "CHECKED" ||
                    feilds.questionType === "MRD" ||
                    feilds.questionType === "DB" ||
                    feilds.questionType === "DBS") && (
                    <>
                      <Grid
                        item
                        xs={12}
                        sm={6}
                        md={6}
                        style={{ marginTop: 15 }}
                      >
                        <FormControlLabel
                          color="primary"
                          control={
                            <Checkbox
                              checked={feilds.goNextPage}
                              onChange={(event) => {
                                let temp = feilds;
                                if (
                                  feilds.goBackPage == true &&
                                  feilds.goNextPage == false
                                ) {
                                  temp.goBackPage = false;
                                }
                                temp.goNextPage = !feilds.goNextPage;
                                setFeilds(temp);
                                setReload(new Date());
                              }}
                              name="gonextpage"
                            />
                          }
                          label={getText("gonextpage", controller.lang)}
                        />
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        sm={6}
                        md={6}
                        style={{ marginTop: 15 }}
                      >
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={feilds.goBackPage}
                              value={feilds.goBackPage}
                              onChange={(event) => {
                                let temp = feilds;
                                if (
                                  feilds.goNextPage == true &&
                                  feilds.goBackPage == false
                                ) {
                                  temp.goNextPage = false;
                                }
                                temp.goBackPage = !feilds.goBackPage;
                                setFeilds(temp);
                                setReload(new Date());
                              }}
                              name="gobackpage"
                            />
                          }
                          label={getText("gobackpage", controller.lang)}
                        />
                      </Grid>
                    </>
                  )}

                  <Grid item xs={12} sm={6} md={6} style={{ marginTop: 15 }}>
                    <FormControlLabel
                      color="primary"
                      control={
                        <Checkbox
                          checked={feilds.mandatory}
                          onChange={() => {
                            let temp = feilds;
                            temp.mandatory = !feilds.mandatory;
                            setFeilds(temp);
                            setReload(new Date());
                          }}
                          name="mandatory"
                        />
                      }
                      label={getText("mandatory", controller.lang)}
                    />
                  </Grid>

                  {(feilds.questionType === "FLATB" ||
                    feilds.questionType === "DB") && (
                    <>
                      <Grid item xs={12} sm={12} md={12}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={feilds.multiMode}
                              onChange={() => {
                                let temp = feilds;
                                temp.multiMode = !feilds.multiMode;
                                setFeilds(temp);

                                setReload(new Date());
                              }}
                              name="multiMode"
                            />
                          }
                          label={getText("multimode", controller.lang)}
                        />
                      </Grid>
                    </>
                  )}
                  {/*    <Grid item xs={12} sm={12} md={12} style={{ marginTop: 15 }}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={feilds.displayTitle}
                          onChange={() => {
                            let temp = feilds;
                            temp.displayTitle = !feilds.displayTitle;
                            setFeilds(temp);
                            setReload(new Date());
                          }}
                          name="displayTitle"
                        />
                      }
                      label={getText("displaytitle", controller.lang)}
                    />
                  </Grid>
                 <Grid container>
                    <Grid item xs={6} sm={6} md={6}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={feilds.fixTop}
                            onChange={() => {
                              let temp = feilds;
                              if (!feilds.fixTop && feilds.fixBottom) {
                                temp.fixBottom = false;
                              }
                              temp.fixTop = !feilds.fixTop;
                              setFeilds(temp);
                              setReload(new Date());
                            }}
                            name="fixTop"
                          />
                        }
                        label={getText("fixtop", controller.lang)}
                      />
                    </Grid>
                    <Grid item xs={6} sm={6} md={6}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={feilds.fixBottom}
                            onChange={() => {
                              let temp = feilds;
                              if (!feilds.fixBottom && feilds.fixTop) {
                                temp.fixTop = false;
                              }
                              temp.fixBottom = !feilds.fixBottom;
                              setFeilds(temp);
                              setReload(new Date());
                            }}
                            name="fixBottom"
                          />
                        }
                        label={getText("fixBottom", controller.lang)}
                      />
                    </Grid>
                  </Grid> */}
                  {feilds.questionType === "CALC" && (
                    <Grid item xs={12} sm={6} md={6} style={{ marginTop: 15 }}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={feilds.showForUser}
                            onChange={() => {
                              let temp = feilds;
                              temp.showForUser = !feilds.showForUser;
                              setFeilds(temp);
                              setReload(new Date());
                            }}
                            name="showForUser"
                          />
                        }
                        label={getText("showforuser", controller.lang)}
                      />
                    </Grid>
                  )}

                  {feilds.questionType === "CALC" && (
                    <>
                      <Grid
                        item
                        xs={12}
                        sm={6}
                        md={6}
                        style={{ marginTop: 35 }}
                      >
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={feilds.isRound}
                              onChange={() => {
                                let temp = feilds;
                                temp.isRound = !feilds.isRound;
                                setFeilds(temp);
                                setReload(new Date());
                              }}
                              name="isRound"
                            />
                          }
                          label={getText("round", controller.lang)}
                        />
                      </Grid>
                      {!feilds.isRound && (
                        <Grid
                          item
                          xs={12}
                          sm={6}
                          md={6}
                          style={{ marginTop: 15 }}
                        >
                          {getText("floatcount", controller.lang)}
                          <TextField
                            id="floatCount"
                            fullWidth
                            type="number"
                            variant="outlined"
                            value={feilds.floatCount}
                            onChange={(event) => {
                              let temp = feilds;
                              temp.floatCount = event.target.value;
                              setFeilds(temp);
                              setReload(new Date());
                            }}
                          />
                        </Grid>
                      )}
                    </>
                  )}
                  {(feilds.questionType === "DB" ||
                    feilds.questionType === "DBS") && (
                    <Grid container>
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        md={12}
                        style={{ marginTop: 15 }}
                      >
                        <div
                          style={{
                            fontSize: 13,
                            fontWeight: "bold",
                            color: "#BD4941",
                          }}
                        >
                          {getText("answerdisplaysize", controller.lang)}
                        </div>
                        <TextField
                          id="answerdisplaysize"
                          variant="outlined"
                          fullWidth
                          value={`${feilds.answerSize}`}
                          onChange={(event) => {
                            let temp = feilds;
                            temp.answerSize = event.target.value;
                            setFeilds(temp);
                            setReload(new Date());
                          }}
                          select={true}
                        >
                          <MenuItem key="12" value={12}>
                            100%
                          </MenuItem>
                          <MenuItem key="6" value={6}>
                            50%
                          </MenuItem>
                        </TextField>
                      </Grid>

                      <Grid
                        item
                        xs={12}
                        sm={12}
                        md={12}
                        style={{ marginTop: 15 }}
                      >
                        {/* <Button
                    fullWidth
                    onClick={(e) => {
                      e.preventDefault();
                      handleOpen();
                    }}
                  >
                    {getText("attachitemsfromexcellfile", controller.lang)}
                  </Button> */}

                        <div className="custom-file">
                          <input
                            type="file"
                            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                            className="custom-file-input"
                            id="ExcelFile"
                            name="ExcelFile"
                            onChange={changeHandler}
                          />
                          <div
                            id="ExcelFileStatus"
                            className="custom-file-label"
                            htmlFor="selectedExcelFile"
                          >
                            {selectedExcelFile && selectedExcelFile.name}
                            {!selectedExcelFile &&
                              getText(
                                "attachitemsfromexcellfile",
                                controller.lang
                              )}
                          </div>
                        </div>
                        <a
                          href="https://server.iclcapp.com/uploads/downloads/samplefile.xlsx"
                          target="_blank"
                          download
                        >
                          {getText("downloadsamplefile", controller.lang)}
                        </a>
                        {/* <DropzoneDialog
                open={openExcel}
                onSave={handleSave}
                acceptedFiles={[
                  "application/docx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                ]}
                showPreviews={true}
                maxFileSize={5000000}
                onClose={handleClose}
                filesLimit={1}
              /> */}
                      </Grid>
                    </Grid>
                  )}
                  {(feilds.questionType === "SELECT" ||
                    feilds.questionType === "FLAT" ||
                    feilds.questionType === "FLATB" ||
                    feilds.questionType === "CHECKED" ||
                    feilds.questionType === "MRD" ||
                    feilds.questionType === "RANGE") && (
                    <Grid item xs={12} sm={12} md={12}>
                      <div>
                        {topAnswers.length > 0 && (
                          <Button
                            onClick={() => {
                              getSubAnswerHandler(
                                topAnswers[topAnswers.length - 1]
                              );
                            }}
                          >
                            بازگشت به رده بالا
                          </Button>
                        )}
                      </div>
                      <NewAnaswer
                        handleOpenRelatdAnswer={handleOpenRelatdAnswer}
                        question={question}
                        capsule={capsule}
                        qustonType={feilds.questionType}
                        answerList={answerList}
                        topAnswerValue={topAnswerValue}
                        topAnswer={topAnswers[topAnswers.length - 1]}
                        setQuestionAnswers={setQuestionAnswers}
                        getSubAnswerHandler={getSubAnswerHandler}
                      />
                    </Grid>
                  )}
                </>
              )}
            </>
          )}
          <Grid container>
            <Grid item xs={4} sm={4} md={4} mt={2} px={2}>
              <Button
                fullWidth
                onClick={() => {
                  setFeilds(emptyFeilds);
                  setSelectedExcelFile();
                  setReload(new Date());
                  resetAddQuestiobtnMode();
                }}
                variant="contained"
                color="secondary"
              >
                <div
                  style={{
                    fontSize: 13,
                    fontWeight: "bold",
                    color: "#FFF",
                  }}
                >
                  {getText("cancel", controller.lang)}
                </div>
              </Button>
            </Grid>
            <Grid item xs={8} sm={8} md={8} mt={2}>
              <Button
                fullWidth
                onClick={submitHandler}
                variant="contained"
                color="primary"
              >
                <div
                  style={{
                    fontSize: 13,
                    fontWeight: "bold",
                    color: "#FFF",
                  }}
                >
                  {getText("submit", controller.lang)}
                </div>
              </Button>
            </Grid>
          </Grid>
        </>
      )}
    </Grid>
  );
};
export default NewQuestion;
